import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  MenuItem,
  Stack,
  SvgIcon,
  TextField,
  Typography,
} from '@mui/material'
import { IconArrowBarRight } from '@tabler/icons-react'
import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { take } from 'remeda'
import { usePatchInventory } from '~/features/inventory/hooks/usePatchInventory'
import { InventoryListRowModel } from '~/features/inventory/types'

type TransferFormProps = {
  rows: InventoryListRowModel[]
  onClose: () => void
  disabled: boolean
}
export const TransferForm = ({ rows, onClose, disabled }: TransferFormProps) => {
  const [open, setOpen] = useState(false)
  const { mutate: patchInventory, isPending } = usePatchInventory()

  const location = take(rows, 1).reduce<InventoryListRowModel['location']>(
    (_, el) => el.location,
    'wollem'
  )

  const { control, handleSubmit } = useForm({
    defaultValues: {
      location,
    },
  })

  const transfer = (data: { location: 'mandarin' | 'wollem' }) => {
    const payload = rows.map((r) => ({ id: r.id, location: data.location }))
    patchInventory(payload, { onSuccess: onClose })
  }
  return (
    <>
      <Button
        endIcon={
          <SvgIcon>
            <IconArrowBarRight />
          </SvgIcon>
        }
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        Move
      </Button>
      <Dialog open={open} PaperProps={{ sx: { minWidth: 400 } }}>
        <DialogTitle>Transfer</DialogTitle>

        <Stack component="form" onSubmit={handleSubmit(transfer)} sx={{ p: 2, gap: 2, flex: 1 }}>
          <Typography variant="body2">Select the store and transfer inventory.</Typography>
          <Controller
            control={control}
            name="location"
            render={({ field }) => (
              <TextField select {...field}>
                <MenuItem value="wollem">Wollem</MenuItem>
                <MenuItem value="mandarin">Mandarin</MenuItem>
              </TextField>
            )}
          />
          <Stack direction="row" sx={{ gap: 1, alignSelf: 'flex-end', mt: 'auto' }}>
            <Button onClick={onClose} variant="outlined">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isPending}
              endIcon={isPending ? <CircularProgress size={14} /> : null}
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </>
  )
}
